import * as React from 'react';
import { Trans } from '~/common/context';
import { ROLES } from '~/common/helpers';
import { useAccessControl } from '~/common/hooks';
import {
  CriteriaEditableBadge,
  CriteriaValueInput,
} from '~/connect/components';
import { ICriteria } from '~/connect/types';

interface CriteriaValuesGridProps {
  criteria: ICriteria;
  onUpdateValue: (
    criteriaId: string,
    valueIndex: number,
    newValue: string,
  ) => void;
  onDeleteValue: (criteriaId: string, valueIndex: number) => void;
  onAddValue: (criteriaId: string, newValue: string) => void;
}

export const CriteriaValuesGrid: React.FC<CriteriaValuesGridProps> = ({
  criteria,
  onUpdateValue,
  onDeleteValue,
  onAddValue,
}) => {
  const acl = useAccessControl();
  return (
    <table className='table table-transparent table-borderless mb-0'>
      <thead>
        <tr>
          <th>
            <Trans i18nKey='app.criteria.list.table.values' />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div className='d-flex flex-wrap gap-2 align-items-center'>
              {criteria.values.map((value, index) => (
                <CriteriaEditableBadge.Root
                  key={value.id}
                  value={value.label}
                  onSubmit={(newValue) =>
                    onUpdateValue(criteria.id, index, newValue)
                  }
                >
                  <CriteriaEditableBadge.Display
                    value={value.label}
                    reserved={Boolean(criteria.isReserved)}
                    isDefault={Boolean(value.default)}
                    onDelete={() => onDeleteValue(criteria.id, index)}
                  />
                  <CriteriaEditableBadge.Form />
                </CriteriaEditableBadge.Root>
              ))}
              {!criteria.isReserved &&
                acl.isGranted([ROLES.ROLE_CRITERIA_UPDATE]) && (
                  <CriteriaValueInput.Root
                    onSubmit={(newValue) => onAddValue(criteria.id, newValue)}
                  >
                    <CriteriaValueInput.Trigger
                      id={`add-value-to-${criteria.name}`}
                    />
                    <CriteriaValueInput.Form />
                  </CriteriaValueInput.Root>
                )}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
